<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb :title="page.title" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
         <v-card>
            <v-toolbar flat color="white">
               <v-toolbar-title>Zone Definitions</v-toolbar-title>
               <v-divider class="mx-4" inset vertical></v-divider>
               <v-spacer></v-spacer>
               <v-btn color="primary" dark @click="loadItems" :loading="loading">Refresh</v-btn>
            </v-toolbar>
            <v-data-table :headers="headers" :items="items" :loading="loading" class="border" no-data-text="No zone definitions"></v-data-table>
         </v-card>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
const axios = require('axios')

export default {
   name: 'MOAZones',
   components: { DashboardLayout, BaseBreadcrumb },
   data() {
      return {
         page: { title: 'Zone Definitions' },
         breadcrumbs: [
            { text: 'Dashboard', disabled: false, to: '/dashboard' },
            { text: 'Zone Definitions', disabled: true },
         ],
         loading: false,
         items: [],
         headers: [
            { text: 'Zone Name', value: 'zonename' },
            { text: 'Definition', value: 'zonedef' },
            { text: 'Description', value: 'zonedesc' },
         ],
      }
   },
   mounted() {
      this.loadItems()
   },
   methods: {
      loadItems() {
         this.loading = true
         axios.get('/admin/zone/list')
            .then((resp) => {
               this.items = resp.data && resp.data.status === 'OK' ? (resp.data.data || []) : []
            })
            .finally(() => {
               this.loading = false
            })
      },
   },
}
</script>
